import { render, staticRenderFns } from "./focus-areas.vue?vue&type=template&id=efb2d0f8&scoped=true&"
import script from "./focus-areas.vue?vue&type=script&lang=js&"
export * from "./focus-areas.vue?vue&type=script&lang=js&"
import style0 from "./focus-areas.vue?vue&type=style&index=0&id=efb2d0f8&scoped=true&lang=css&"
import style1 from "./focus-areas.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb2d0f8",
  null
  
)

export default component.exports